export const getSongStatusBgColor = (songStatus) => {
    songStatus = songStatus?.replaceAll(' ', '_')?.toLowerCase() || songStatus;
    if (songStatus) {
        switch (songStatus) {
            case 'in_review':
            case 'redelivery':
            case 'redelivery_requested':
            case 'takedown_requested':
                {
                    return "#26C6F9"
                }
            case 'pending':
                {
                    return "#DAA827"
                }
            case 'ready_for_release':
            case 'ready_for_redelivery':
                {
                    return "#FDB528"
                }
            case 'no_status':
                {
                    return "#FDB528"
                }
            case 'released':
            case 'redelivered':
                {
                    return ' #787EFF'
                }
            case 'verified':
                {
                    return ' #787EFF'
                }
            case 'accepted':
                {
                    return ' #787EFF'
                }
            case 'rejected':
            case 'reject':
            case 'takedown':
                {
                    return '#FF4D49'
                }
            case 'unverified':
                {
                    return '#FF4D49'
                }
            case 'approved':
                {
                    return '#787EFF'
                }
            // case 'ReDelivery':
            //     {
            //         return ' #3EBD02'
            //     }
            default:
                return '#6c757d'
        }
    }
}
